import { render, staticRenderFns } from "./QualityControlIndexComponent.vue?vue&type=template&id=fa335b20"
import script from "./QualityControlIndexComponent.vue?vue&type=script&lang=js"
export * from "./QualityControlIndexComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports